import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function SnookerNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Snooker",
    links: [
      {href: "/snooker", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

SnookerNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default SnookerNav



// WEBPACK FOOTER //
// ./modules/Snooker/nav/SnookerNav.js